import { render } from "./ProfilDewan.vue?vue&type=template&id=6eb55d50"
import script from "./ProfilDewan.vue?vue&type=script&lang=js"
export * from "./ProfilDewan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__